export default {
    state: {
        steps: {
            employeeForm: {
                active: 1
            },
        },
        errors: null,
        isLoading: false,
        isAuth: false,
        drawer: null,
        showHeader: true,
        snackbar: {
            show: false,
            text: '',
            type: 'info'
        },
        apiSocketConnected: false,
        sidebarMini: false,
        isPhoneCall: false,
        isCountrySlugFetched: false,
    },
    getters: {
        getEmployeeFormSteps: (state) => state.steps.employeeForm,
        getErrors: (state) => state.errors,
        getEmployeeFormStepActive: (state) => state.steps.employeeForm.active,
        getIsLoading: (state) => state.isLoading,
        getIsAuth: (state) => state.isAuth,
        getDrawer: (state) => state.drawer,
        getShowHeader: (state) => state.showHeader,
    },
    mutations: {
        SET_IS_LOADING_DATA(state, payload) {
            state.isLoading = payload;
        },
        SET_IS_AUTH_DATA(state, payload) {
            state.isAuth = payload;
        },
        SET_DRAWER_DATA(state, payload) {
            state.drawer = payload;
        },
        SET_EMPLOYEE_FORM_STEP_ACTIVE_DATA(state, payload) {
            state.steps.employeeForm.active = payload;
        },
        SET_ERRORS_DATA(state, payload) {
            state.errors = payload;
        },
        CLEAR_ERRORS_DATA(state) {
            state.errors = null;
        },
        SET_SHOW_HEADER_DATA(state, payload) {
            state.showHeader = payload;
        },
        SET_SNACKBAR_DATA(state, {
            text,
            type,
            buttonRefresh,
            duration
        }) {
            state.snackbar = {
                show: true,
                text,
                type,
                buttonRefresh,
                duration
            };
        },
        RESET_SNACKBAR_DATA(state) {
            state.snackbar = {
                show: false,
                text: null,
                type: 'info'
            };
        },
        SET_SIDEBAR_MINI_DATA(state, payload) {
            state.sidebarMini = payload;
        },
        SET_API_SOCKET_CONNECTED(state, payload) {
            state.apiSocketConnected = payload;
        },
        SET_IS_CALL_PHONE_DATA(state, payload) {
            state.isPhoneCall = payload;
        },
        SET_IS_CALL(state, payload) {
            state.isCall = payload;
        },
        SET_IS_COUNTRY_SLUG_FETCHED(state, payload) {
            state.isCountrySlugFetched = payload;
        },
    },
    actions: {
        setIsLoadingData({
            commit
        }, payload) {
            commit('SET_IS_LOADING_DATA', payload);
        },
        setIsAuthData({
            commit
        }, payload) {
            commit('SET_IS_AUTH_DATA', payload);
        },
        setDrawerData({
            commit
        }, payload) {
            commit('SET_DRAWER_DATA', payload);
        },
        setEmployeeFormStepActiveData({
            commit
        }, payload) {
            commit('SET_EMPLOYEE_FORM_STEP_ACTIVE_DATA', payload);
        },
        setErrorsData({
            commit
        }, payload) {
            commit('SET_ERRORS_DATA', payload);
        },
        clearErrorsData({
            commit
        }) {
            commit('CLEAR_ERRORS_DATA');
        },
        setShowHeaderData({
            commit
        }, payload) {
            commit('SET_SHOW_HEADER_DATA', payload);
        },
    },
};
